import { AppConfigModel } from "../abstract/app-config.model";

export class Feature extends AppConfigModel {

    static override CLASS_NAME: string = 'Feature';

    readonly description!: string;
}
